import React, { useEffect, useState, useCallback } from "react";
import {
	Button,
	Input,
	Spinner,
	useDisclosure
} from "@heroui/react";
import { FilterIcon, ImportIcon, DownloadIcon, SearchIcon } from "../../utils/svgIcons";
import DynamicPopover from "../DynamicPopover/DynamicPopover";
import LeadsData from './LeadData'
import FilterData from "./FilterData";
import { useDispatch } from "react-redux";
import useDebounce from "../../utils/useDebounce";
import UploadFile from "../UploadFile/UploadFile";
import UploadRetailFile from "../UploadFile/UploadRetailFile";
import ModalBox from "../PopupModals/Modal";
import toast, { Toaster } from 'react-hot-toast';
import { FaArrowRight } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { getFilterDropdownOptions } from "../../redux/actions/allLeadsActions";


function LeadsDataWithFilter({
	availableFilter,
	getGoogleSignedRecordingUrl,
	availableFilterValues,
	leadType,
	fetchColumns,
	allLeadsData,
	columnsData,
	columnLoading,
	getAllLeads,
	getleadViewDetails,
	getleadDetails,
	getAllStatusFields,
	getDealersAndAreas,
	getFreshWorkFields,
	getPincodeDirectoryFields,
	uploadleads,
	loading,
	matchedPermission,
	downloadLeads,
	savePreference,
	fetchPreferences,
	deletePreference,
	fetchOEMHistory,
	getTenureDownpayRangeFields,
	getFilterDropdownOptions,
	columnType = null,
	apiType = null,
	getUniqueFields,
	getInboundUniqueFields,
	getBrandFields,
	uploadRetailLeads
}) {
	const dispatch = useDispatch();

	// Modal hooks
	const { isOpen, onOpen, onClose } = useDisclosure();

	// filter sidebar hooks
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	// Dynamic Columns hooks
	const [selectedColumns, setSelectedColumns] = useState([]);

	// Search hooks
	const [searchInput, setSearchInput] = useState('');
	const [searchApplied, setSearchApplied] = useState(false);
	const [showOptions, setShowOptions] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	// Upload Leads hooks
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const [isRetailModalOpen, setIsRetailModalOpen] = useState(false);

	// Download leads hooks
	const [isDownloadLeadsModal, setIsDownloadLeadsModal] = useState(false);
	const [downloading, setDownloading] = useState(false);
	const [useDynamicColumns, setUseDynamicColumns] = useState(false);

	// Filter hooks
	const [applyFilter, setApplyFilter] = useState(false);
	const [selectedFilters, setSelectedFilters] = useState([]);
	const [filter, setFilter] = useState(availableFilter);
	const [filterValues, setFilterValues] = useState({});
	const [addFilter, setAddFilter] = useState(false);
	const [search, setSearch] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [filterData, setFilterData] = useState({ generalFilter: availableFilterValues });
	const [isDropdownLoading, setIsDropdownLoading] = useState(true);

	// Ensure that when the leadType or available config changes, we reset the internal states
	useEffect(() => {
		setFilter(availableFilter);
		setFilterData({ generalFilter: availableFilterValues });
		setIsDropdownLoading(true);
	}, [availableFilter, availableFilterValues]);

	// Date Rang Hooks
	const [isDateRangeOpen, setIsDateRangeOpen] = useState(false);
	const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
	const [openDateRangeKey, setOpenDateRangeKey] = useState(null);

	// Additional Filters
	const [checkedFilters, setCheckedFilters] = useState({});
	const [dateRangeFilters, setDateRangeFilters] = useState({});

	// Pagination hooks
	const [pageLimit, setPageLimit] = useState('10');

	// Search by Mobile No.
	const handleSearchInputChange = (e) => {
		setSearchInput(e.target.value);
	}

	const searchFunctions = () => {
		if (searchInput.trim() === '') {
			if (searchApplied) {
				clearSearch();
			}
			return;
		}

		setSearchApplied(true); // mark search as active
		getAllLeads({
			page: 1,
			limit: pageLimit,
			search: searchInput.trim(),
			company: leadType
		});

		setFilterValues({
			...filterValues,
			search: searchInput.trim()
		})
	};

	const clearSearch = () => {
		setSearchInput('');
		setSearchApplied(false);

		getAllLeads({
			page: 1,
			limit: pageLimit,
			company: leadType
		});

		setFilterValues({
			...filterValues,
			search: ""
		})
	};

	// Debounce search input
	const debouncedSearch = useDebounce(searchInput, 500);

	const fetchLeadData = async () => {
		// const searchField = leadType === "All" ? "search" : "mobile";
		const bodyObj = {
			page: 1,
			limit: 10,
			search: debouncedSearch,
			company: leadType
		};


		setIsLoading(true);

		Object.keys(filter).forEach((key) => {
			const rawFormattedKey = key.replace(/\s+/g, "_").toLowerCase();
			const formattedKey = rawFormattedKey === 'battery_wise_exploration' ? 'batteryWiseExploration' : rawFormattedKey;

			if (formattedKey === 'simple_sent_by_inc_date') {
				if (filter[key]?.startDate && filter[key]?.endDate) {
					bodyObj.simple_sent_start_date = new Date(filter[key].startDate).toISOString();
					bodyObj.simple_sent_end_date = new Date(filter[key].endDate).toISOString();
				}
				return;
			}
			if (formattedKey.endsWith('_inc_date')) return;
			if (key === 'date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.startDate = new Date(filter[key].startDate).toISOString();
				bodyObj.endDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'ola_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.ola_addon_startdate = new Date(filter[key].startDate).toISOString();
				bodyObj.ola_addon_enddate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'ola_order_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.orderedStartDate = new Date(filter[key].startDate).toISOString();
				bodyObj.orderedEndDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'filter_by_updated_at' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.updateStartDate = new Date(filter[key].startDate).toISOString();
				bodyObj.updateEndDate = new Date(filter[key].endDate).toISOString();
			}
			else if ((formattedKey === 'retaildate' || formattedKey === 'tvs_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.tvs_start_retailDate = new Date(filter[key].startDate).toISOString();
				bodyObj.tvs_end_retailDate = new Date(filter[key].endDate).toISOString();
			}
			else if ((formattedKey === 'retaildate' || formattedKey === 'ola_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.ola_start_retailDate = new Date(filter[key].startDate).toISOString();
				bodyObj.ola_end_retailDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'ola_verification_date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.ola_start_verificationDate = new Date(filter[key].startDate).toISOString();
				bodyObj.ola_end_verificationDate = new Date(filter[key].endDate).toISOString();
			}
			else if ((formattedKey === 'retaildate' || formattedKey === 'revolt_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.revolt_start_retailDate = new Date(filter[key].startDate).toISOString();
				bodyObj.revolt_end_retailDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'revolt_booking_date' && filter[key]?.startDate) {
				bodyObj.revolt_start_bookingDate = new Date(filter[key].startDate).toISOString();
				if (filter[key]?.endDate) bodyObj.revolt_end_bookingDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'revolt_tr_completed_date' && filter[key]?.startDate) {
				bodyObj.revolt_start_trCompletedDate = new Date(filter[key].startDate).toISOString();
				if (filter[key]?.endDate) bodyObj.revolt_end_trCompletedDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'revolt_tr_scheduled_date' && filter[key]?.startDate) {
				bodyObj.revolt_start_trScheduledDate = new Date(filter[key].startDate).toISOString();
				if (filter[key]?.endDate) bodyObj.revolt_end_trScheduledDate = new Date(filter[key].endDate).toISOString();
			}
			else if (Array.isArray(filter[key]) && filter[key].length > 0) {
				bodyObj[formattedKey] = filter[key].toString();
			}
			else if (filter[key] !== null && filter[key] !== undefined) {
				bodyObj[formattedKey] = filter[key];
			}
		});

		// Addon date ranges
		const dateRanges = [];
		for (const key in filter) {
			if (key.endsWith('_inc_date') && key !== 'simple_sent_by_inc_date') {
				const parentTitle = key.replace(/_inc_date$/, '');
				const isChecked = checkedFilters[parentTitle] === true;
				const range = filter[key];
				if (isChecked && range?.startDate && range?.endDate) {
					dateRanges.push(range);
				}
			}
		}
		if (dateRanges.length > 1) {
			bodyObj.isHistoric = true;
			const timestamps = dateRanges.map((range) => ({
				start: new Date(range.startDate).getTime(),
				end: new Date(range.endDate).getTime(),
			}));

			const minStart = Math.min(...timestamps.map((d) => d.start));
			const maxEnd = Math.max(...timestamps.map((d) => d.end));

			// Total duration of range in ms
			const duration = maxEnd - minStart;

			// Compute new mid-range (preserving original time format)
			const midStart = new Date(minStart + duration / 4); // shift to 25% into the period
			const midEnd = new Date(minStart + (3 * duration) / 4); // shift to 75% into the period

			// Normalize to fixed time format
			midStart.setUTCHours(18, 30, 0, 0); // 00:00 IST
			midEnd.setUTCHours(18, 29, 59, 999); // 11:59:59 IST

			bodyObj.updatedAtStartDate = midStart.toISOString();
			bodyObj.updatedAtEndDate = midEnd.toISOString();
		} else if (dateRanges.length === 1) {
			bodyObj.isHistoric = true;
			bodyObj.updatedAtStartDate = new Date(dateRanges[0].startDate).toISOString();
			bodyObj.updatedAtEndDate = new Date(dateRanges[0].endDate).toISOString();
		}
		// Over

		if (leadType) {
			try {
				await getAllLeads(bodyObj).finally(() => {
					setIsLoading(false);
				});
			} catch (error) {
				console.error('Error fetching leads:', error);
			} finally {
				setIsLoading(false);
				setShowOptions(false);
			}
		}

	}

	useEffect(() => {
		fetchLeadData();
	}, [dispatch,]);

	// Load the columns of this page (again when the page type changes, e.g. All -> Simple leads)
	useEffect(() => {
		dispatch(fetchColumns(columnType));
	}, [dispatch, columnType]);
	//debouncedSearch


	// Filter Sidebar toggle
	const toggleFilterSidebar = () => {
		setIsSidebarOpen(prev => !prev);
	};

	// Every time the column list of this page is (re)loaded, select that page's default columns
	useEffect(() => {
		if (columnsData && columnsData.length > 0) {
			const data = columnsData.filter(col => col?.default).map(col => col?.uid);
			setSelectedColumns(data);
		}
	}, [columnsData]);

	// Remember the current column selection of this page
	useEffect(() => {
		if (leadType && (selectedColumns && selectedColumns.length > 0)) {
			const savedColumns = JSON.parse(localStorage.getItem('savedColumns')) || {};
			savedColumns[leadType] = selectedColumns;
			localStorage.setItem('savedColumns', JSON.stringify(savedColumns));
		}
	}, [selectedColumns, filter]);

	// Toggle individual selection
	const toggleItem = (uid) => {
		setSelectedColumns((prev) =>
			prev.includes(uid) ? prev.filter((item) => item !== uid) : [...prev, uid]
		);
	};

	// Formated number value
	function formatNumberValue(number) {
		if (typeof number !== 'number') {
			return 'Invalid input'; // Handle non-numeric inputs
		}
		return new Intl.NumberFormat('en-IN').format(number);
	}

	// Handle Filter
	const handleConfirmFilter = () => {
		setApplyFilter(true);
		onClose(onClose);
		setFilterValues({});
		const dateRanges = [];
		const bodyObj = { page: 1, limit: pageLimit, search: debouncedSearch, company: leadType }

		// Set dynamic filter
		Object.keys(filter).forEach((key) => {
			const rawFormattedKey = key.replace(/\s+/g, "_").toLowerCase();
			const formattedKey = rawFormattedKey === 'battery_wise_exploration' ? 'batteryWiseExploration' : rawFormattedKey;

			if (formattedKey === 'simple_sent_by_inc_date') {
				if (filter[key]?.startDate && filter[key]?.endDate) {
					bodyObj.simple_sent_start_date = new Date(filter[key].startDate).toISOString();
					bodyObj.simple_sent_end_date = new Date(filter[key].endDate).toISOString();
				}
				return;
			}
			if (formattedKey.endsWith("_inc_date")) return;

			if (key === 'date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.startDate = new Date(filter[key].startDate).toISOString();
				bodyObj.endDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'ola_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.ola_addon_startdate = new Date(filter[key].startDate).toISOString();
				bodyObj.ola_addon_enddate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'ola_order_status_date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.orderedStartDate = new Date(filter[key].startDate).toISOString();
				bodyObj.orderedEndDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'filter_by_updated_at' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.updateStartDate = new Date(filter[key].startDate).toISOString();
				bodyObj.updateEndDate = new Date(filter[key].endDate).toISOString();
			}
			else if ((formattedKey === 'retaildate' || formattedKey === 'tvs_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.tvs_start_retailDate = new Date(filter[key].startDate).toISOString();
				bodyObj.tvs_end_retailDate = new Date(filter[key].endDate).toISOString();
			}
			else if ((formattedKey === 'retaildate' || formattedKey === 'ola_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.ola_start_retailDate = new Date(filter[key].startDate).toISOString();
				bodyObj.ola_end_retailDate = new Date(filter[key].endDate).toISOString();
			}
			else if (formattedKey === 'ola_verification_date' && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.ola_start_verificationDate = new Date(filter[key].startDate).toISOString();
				bodyObj.ola_end_verificationDate = new Date(filter[key].endDate).toISOString();
			}
			else if ((formattedKey === 'retaildate' || formattedKey === 'revolt_retail_date') && filter[key]?.startDate && filter[key]?.endDate) {
				bodyObj.revolt_start_retailDate = new Date(filter[key].startDate).toISOString();
				bodyObj.revolt_end_retailDate = new Date(filter[key].endDate).toISOString();
			}
			else if (Array.isArray(filter[key]) && filter[key].length > 0) {
				bodyObj[formattedKey] = filter[key].toString();
			}
			else if (filter[key] !== null && filter[key] !== undefined) {
				bodyObj[formattedKey] = filter[key];
			}
		});

		for (const key in filter) {
			if (key.endsWith('_inc_date') && key !== 'simple_sent_by_inc_date') {
				const parentTitle = key.replace(/_inc_date$/, '');
				const isChecked = checkedFilters[parentTitle] === true;
				const range = filter[key];
				if (isChecked && range?.startDate && range?.endDate) {
					dateRanges.push(range);
				}
			}
		}

		if (dateRanges.length > 1) {
			bodyObj.isHistoric = true;
			const timestamps = dateRanges.map((range) => ({
				start: new Date(range.startDate).getTime(),
				end: new Date(range.endDate).getTime(),
			}));

			const minStart = Math.min(...timestamps.map((d) => d.start));
			const maxEnd = Math.max(...timestamps.map((d) => d.end));

			// Total duration of range in ms
			const duration = maxEnd - minStart;

			// Compute new mid-range (preserving original time format)
			const midStart = new Date(minStart + duration / 4); // shift to 25% into the period
			const midEnd = new Date(minStart + (3 * duration) / 4); // shift to 75% into the period

			// Normalize to fixed time format
			midStart.setUTCHours(18, 30, 0, 0); // 00:00 IST
			midEnd.setUTCHours(18, 29, 59, 999); // 11:59:59 IST

			bodyObj.updatedAtStartDate = midStart.toISOString();
			bodyObj.updatedAtEndDate = midEnd.toISOString();
		} else if (dateRanges.length === 1) {
			bodyObj.isHistoric = true;
			bodyObj.updatedAtStartDate = new Date(dateRanges[0].startDate).toISOString();
			bodyObj.updatedAtEndDate = new Date(dateRanges[0].endDate).toISOString();
		}

		getAllLeads(bodyObj).finally(() => {
			setApplyFilter(false);
			setFilterValues(bodyObj);
			setIsSidebarOpen(false);
		});
	}

	// Handle Reset Filter
	const toggleResetFilter = () => {
		setAddFilter(false);
		setSearchTerm("");
		setFilter(Object.keys(availableFilter).reduce((acc, key) => {
			acc[key] = [];
			return acc;
		}, {}));
		setCheckedFilters({});
		setDateRange({ startDate: null, endDate: null });
		setAddFilter(false);
		setSearch(false);
		setSelectedFilters([])
		const bodyObj = { page: 1, limit: pageLimit, search: debouncedSearch, company: leadType }
		getAllLeads(bodyObj).finally(() => {
			setIsSidebarOpen(false);
		});
	}

	// Handle Ooen Download Leads Modal
	const toggleDownloadLeadsModal = () => {
		setIsDownloadLeadsModal(true);
	};

	// Handle Download Leads
	const handleDownloadLeads = () => {
		setDownloading(true)
		setIsDownloadLeadsModal(false);
		handleConfirmDownloadLeads();
	};

	const handleConfirmDownloadLeads = async () => {
		setDownloading(true)
		const cleanedFilter = Object.fromEntries(
			Object.entries(filterValues).filter(([key, value]) => {
				if (Array.isArray(value)) return value.length > 0;
				if (typeof value === 'object' && value !== null) return Object.keys(value).length > 0;
				return value !== "" && value !== null && value !== undefined;
			})
		);

		// Add dynamic columns parameters if enabled
		if (useDynamicColumns && selectedColumns.length > 0) {
			cleanedFilter.dynamicColumns = 'true';
			cleanedFilter.columns = selectedColumns.join(',');
		}

		await downloadLeads(cleanedFilter, leadType).then((res) => {
			if (res) {
				const url = res.data.result;
				const link = document.createElement('a');
				// link.href = url;
				// link.download = url
				// link.setAttribute('download', "Lead-list.xlsx");
				toast.success(res?.data?.message || 'Excel file downloaded successfully!')
				setDownloading(false)
				setTimeout(() => {
					link.click();
					link.remove();
				}, 1000);
			} else {
				setDownloading(false);
				toast.error('Can not get response from api!')
			}
		}).catch(err => {
			setDownloading(false)
			toast.error(err?.response?.data?.error || 'Can not get response from api! Please try again later.')
		})
	}

	// Set dynamic filters data
	useEffect(() => {
		// First API call
		const fetchData = async () => {
			setIsDropdownLoading(true);
			const promises = [];

			// Fetch decoupled filter options asynchronously
			const p1 = getFilterDropdownOptions()?.then(filterOptRes => {
				if (filterOptRes?.data?.result) {
					const { subBrandList = [], cbrandList = [], otpVerificationOptions = [], simpleSenders = [] } = filterOptRes.data.result;

					const simpleSenderOptions = simpleSenders.map(u => ({ label: `${u.name}`, value: u.id }));

					const subBrandOptions = subBrandList.map(sub_brand => ({ label: sub_brand, value: sub_brand }));
					const cBrandOptions = cbrandList.map(cbrand => ({ label: cbrand, value: cbrand }));
					const otpOpts = otpVerificationOptions.map(option => ({
						label: option == true ? 'Verified' : option == false ? 'Not Verified' : option == 3 ? 'Not Exist' : '',
						value: option,
					}));

					setFilterData(prevData => ({
						...prevData,
						generalFilter: prevData.generalFilter.map(filter => {
							if (filter.title === 'sub_brand') return { ...filter, options: subBrandOptions };
							if (filter.title === 'cbrand') return { ...filter, options: cBrandOptions };
							if (filter.title === 'otp_verified') return { ...filter, options: otpOpts };
							if (filter.title === 'simple_sent_by') return { ...filter, options: simpleSenderOptions };
							return filter;
						})
					}));
				}
			}).catch(err => console.error("Error fetching filter options:", err));
			promises.push(p1);

			if (typeof getBrandFields === 'function') {
				const pBrand = getBrandFields()?.then(brandRes => {
					if (brandRes?.data?.result) {
						const brands = brandRes.data.result;
						const brandOptions = brands.map(brand => ({ label: brand, value: brand }));
						setFilterData(prevData => ({
							...prevData,
							generalFilter: prevData.generalFilter.map(filter => {
								if (filter.title === 'Brand') return { ...filter, options: brandOptions };
								return filter;
							})
						}));
					}
				}).catch(err => console.error("Error fetching brand fields:", err));
				if (pBrand) promises.push(pBrand);
			}

			if (typeof getFreshWorkFields === 'function') {
				const pFreshWork = getFreshWorkFields()?.then(freshRes => {
					if (freshRes?.data?.result) {
						const freshworkbrand = freshRes.data.result;
						const freshWorkOptions = freshworkbrand.filter(data => data !== "null" && data !== "sample_value" && data !== null && data !== undefined && data !== "").map(data => ({ label: String(data), value: data }));
						setFilterData(prevData => ({
							...prevData,
							generalFilter: prevData.generalFilter.map(filter => {
								if (filter.title === 'subSource' || filter.title === 'freshworkbrand') return { ...filter, options: freshWorkOptions };
								return filter;
							})
						}));
					}
				}).catch(err => console.error("Error fetching freshwork brand fields:", err));
				if (pFreshWork) promises.push(pFreshWork);
			}

			const p2 = getAllStatusFields()?.then(statusResponse => {
				const {
					olaStatus = [],
					vidaStatus = [],
					ampereAvailable = [],
					rangeOptions = [],
					batteryOptions = [],
					callYesOptions = [],
					languageOptions = [],
					tvsPurchaseModel = [],
					tvsStatus = [],
					revoltModels = [],
					utmMediumOptions = [],
					utmCampaignOptions = [],
					utmContentOptions = [],
					utmTermOptions = [],
					adGroupOptions = [],
				} = statusResponse?.data?.result || {};

				// Transform all options
				const transformOptions = (data) => (data || [])
					.filter(item => item !== null && item !== undefined && item !== "")
					.map(item => ({
						label: String(item),
						value: item
					}));

				const updates = {
					olaObj: transformOptions(olaStatus),
					vidaObj: transformOptions(vidaStatus),
					ampereObj: transformOptions(ampereAvailable),
					rangeOptions: transformOptions(rangeOptions),
					batteryOptions: transformOptions(batteryOptions),
					callYesOptions: transformOptions(callYesOptions),
					languageOptions: transformOptions(languageOptions),
					tvs_purchased_model: transformOptions(tvsPurchaseModel),
					tvs_status: transformOptions(tvsStatus),
					revoltmodel: transformOptions(revoltModels),
					utm_medium: transformOptions(utmMediumOptions),
					utm_campaign: transformOptions(utmCampaignOptions),
					utm_content: transformOptions(utmContentOptions),
					utm_term: transformOptions(utmTermOptions),
					ad_group: transformOptions(adGroupOptions),
				};

				// Update all filters at once
				setFilterData(prevData => ({
					...prevData,
					generalFilter: prevData.generalFilter.map(filter => {
						switch (filter.title) {
							case 'Range':
								return { ...filter, options: updates.rangeOptions };
							case 'Battery_Wise_Exploration':
								return { ...filter, options: updates.batteryOptions };
							case 'call_yes':
								return { ...filter, options: updates.callYesOptions };
							case 'Language':
								return { ...filter, options: updates.languageOptions };
							case 'Status':
							case 'Ola_Status':
								return { ...filter, options: updates.olaObj };
							case 'tvs_status':
								return { ...filter, options: updates.tvs_status };
							case 'tvs_purchased_model':
								return { ...filter, options: updates.tvs_purchased_model };
							case 'revoltmodel':
								return { ...filter, options: updates.revoltmodel };
							case 'utm_medium':
								return { ...filter, options: updates.utm_medium };
							case 'utm_campaign':
								return { ...filter, options: updates.utm_campaign };
							case 'utm_content':
								return { ...filter, options: updates.utm_content };
							case 'utm_term':
								return { ...filter, options: updates.utm_term };
							case 'ad_group':
								return { ...filter, options: updates.ad_group };
							default:
								return filter;
						}
					})
				}));
			}).catch(err => console.error("Error fetching status fields:", err));
			promises.push(p2);

			const p3 = getPincodeDirectoryFields()?.then((res) => {
				const result = res.data.result[0];
				const pincodeOptions = result.uniquePincodes.map((data) => {
					return { label: data, value: data };
				});

				const postalStateOptions = result.groupedResults.map((data) => {
					return { label: data.postal_state, value: data.postal_state };
				});

				const postalCityOptions = result.groupedResults.reduce((acc, data) => {
					data.uniquePostalCities.forEach((city) => {
						acc.push({ label: city, value: city });
					});
					return acc;
				}, []);

				const evindiaCityOptions = result.groupedResults.reduce((acc, data) => {
					data.uniqueEvindiaCities.forEach((city) => {
						acc.push({ label: city, value: city });
					});
					return acc;
				}, []);

				setFilterData(prevData => ({
					...prevData,
					generalFilter: prevData.generalFilter.map(filter => {
						if (filter.title === 'Pincode') {
							return { ...filter, options: pincodeOptions };
						}
						if (filter.title === 'PO_State') {
							return { ...filter, options: postalStateOptions };
						}
						if (filter.title === 'PO_City') {
							return { ...filter, options: postalCityOptions };
						}
						if (filter.title === 'EVINDIA_CITY_NAME') {
							return { ...filter, options: evindiaCityOptions };
						}
						return filter;
					}),
				}));
			}).catch(err => console.error("Error fetching pincode directory fields:", err));
			promises.push(p3);

			// Tenure, Down Payment & Range Fields
			const p4 = getTenureDownpayRangeFields()?.then((res) => {
				const { uniqueTenure, uniqueDownpay, uniqueRange, uniqueBatteryWiseExploration, uniqueCallYes, uniqueLanguage } = res.data.result;

				const tenureOptions = uniqueTenure.map((data) => ({
					label: data,
					value: data,
				}));

				const downpayOptions = uniqueDownpay.map((data) => ({
					label: `${data}`, // Convert numbers to strings for consistent labeling
					value: data,
				}));

				const rangeOptions = uniqueRange.map((data) => ({
					label: data,
					value: data,
				}));

				const batteryWiseExplorationOptions = uniqueBatteryWiseExploration.map((data) => ({
					label: data,
					value: data,
				}));

				const callYesOptions = uniqueCallYes.map((data) => ({
					label: data,
					value: data,
				}));

				const languageOptions = uniqueLanguage.map((data) => ({
					label: data,
					value: data,
				}));

				setFilterData(prevData => ({
					...prevData,
					generalFilter: prevData.generalFilter.map(filter => {
						if (filter.title === 'Tenure') {
							return { ...filter, options: tenureOptions };
						}
						if (filter.title === 'Down_Payment') {
							return { ...filter, options: downpayOptions };
						}
						if (filter.title === 'Range') {
							return { ...filter, options: rangeOptions };
						}
						if (filter.title === 'Battery_Wise_Exploration') {
							return { ...filter, options: batteryWiseExplorationOptions };
						}
						if (filter.title === 'call_yes') {
							return { ...filter, options: callYesOptions };
						}
						if (filter.title === 'Language') {
							return { ...filter, options: languageOptions };
						}
						return filter;
					}),
				}));
			}).catch(err => console.error("Error fetching tenure downpay range fields:", err));
			promises.push(p4);

			if (leadType === "Dialshree") {
				const p5 = getUniqueFields()?.then((res) => {
					const { uniqueDownPayment, uniqueEvindiaBrand, uniqueEvindiaCity, uniqueLoan, uniquePincode, uniqueRange, uniqueSource, uniqueState, uniqueTenure } = res.data.result;

					const downPaymentOptions = uniqueDownPayment?.map((data) => {
						return { label: data, value: data };
					});

					const evIndiaBrandOptions = uniqueEvindiaBrand?.map((data) => {
						return { label: data, value: data };
					});

					const evIndiacityOptions = uniqueEvindiaCity?.map((data) => {
						return { label: data, value: data };
					});

					const loanOptions = uniqueLoan?.map((data) => {
						return { label: data, value: data };
					});

					const pincodeOptions = uniquePincode?.map((data) => {
						return { label: data, value: data };
					});

					const rangeOptions = uniqueRange?.map((data) => {
						return { label: data, value: data };
					});

					const stateOptions = uniqueState?.map((data) => {
						return { label: data, value: data };
					});

					const tenureOptions = uniqueTenure?.map((data) => {
						return { label: data, value: data };
					});

					const sourceOptions = uniqueSource?.map((data) => {
						return { label: data, value: data };
					});

					setFilterData(prevData => ({
						...prevData,
						generalFilter: prevData.generalFilter.map(filter => {
							if (filter.title === 'down_payment') {
								return { ...filter, options: downPaymentOptions };
							}
							if (filter.title === 'source') {
								return { ...filter, options: sourceOptions };
							}
							if (filter.title === 'evindia_brand') {
								return { ...filter, options: evIndiaBrandOptions };
							}
							if (filter.title === 'state') {
								return { ...filter, options: stateOptions };
							}
							if (filter.title === 'evindia_city') {
								return { ...filter, options: evIndiacityOptions };
							}
							if (filter.title === 'pincode') {
								return { ...filter, options: pincodeOptions };
							}
							if (filter.title === 'evindia_brand') {
								return { ...filter, options: evIndiaBrandOptions };
							}
							if (filter.title === 'range') {
								return { ...filter, options: rangeOptions };
							}
							if (filter.title === 'loan') {
								return { ...filter, options: loanOptions };
							}
							if (filter.title === 'tenure') {
								return { ...filter, options: tenureOptions };
							}
							return filter;
						})
					}));
				}).catch(err => console.error("Error fetching unique fields:", err));
				promises.push(p5);
			}

			if (leadType === "Dialshreeinbound") {
				const p6 = getInboundUniqueFields()?.then((res) => {
					const { uniqueCallDescription, uniqueStatus, uniqueCallType, uniqueSource, uniqueCity, uniqueState, uniquePostalCode, uniqueSubSource } = res.data.result;

					const callDescriptionOptions = uniqueCallDescription?.map((data) => {
						return { label: data, value: data };
					});

					const statusOptions = uniqueStatus?.map((data) => {
						return { label: data, value: data };
					});

					const callTypeOptions = uniqueCallType?.map((data) => {
						return { label: data, value: data };
					});

					const sourceOptions = uniqueSource?.map((data) => {
						return { label: data, value: data };
					});

					const cityOptions = uniqueCity?.map((data) => {
						return { label: data, value: data };
					});

					const stateOptions = uniqueState?.map((data) => {
						return { label: data, value: data };
					});

					const postalCodeOptions = uniquePostalCode?.map((data) => {
						return { label: data, value: data };
					});

					const subSourceOptions = uniqueSubSource?.map((data) => {
						return { label: data, value: data };
					});

					setFilterData(prevData => ({
						...prevData,
						generalFilter: prevData.generalFilter.map(filter => {
							if (filter.title === 'call_description') {
								return { ...filter, options: callDescriptionOptions };
							}
							if (filter.title === 'status') {
								return { ...filter, options: statusOptions };
							}
							if (filter.title === 'callType') {
								return { ...filter, options: callTypeOptions };
							}
							if (filter.title === 'source') {
								return { ...filter, options: sourceOptions };
							}
							if (filter.title === 'city') {
								return { ...filter, options: cityOptions };
							}
							if (filter.title === 'state') {
								return { ...filter, options: stateOptions };
							}
							if (filter.title === 'postal_code') {
								return { ...filter, options: postalCodeOptions };
							}
							if (filter.title === 'subSource') {
								return { ...filter, options: subSourceOptions };
							}
							return filter;
						})
					}));
				}).catch(err => console.error("Error fetching inbound unique fields:", err));
				promises.push(p6);
			}

			if (leadType === "Ola") {
				const p7 = getDealersAndAreas()?.then((res) => {
					const { areasList, dealersList } = res.data;

					const dealAreasList = areasList?.map((data) => {
						return { label: data, value: data };
					});

					const dealerList = dealersList?.map((data) => {
						return { label: data.dealerName, value: data.dealerId };
					});

					setFilterData(prevData => ({
						...prevData,
						generalFilter: prevData.generalFilter.map(filter => {
							if (filter.title === 'area') {
								return { ...filter, options: dealAreasList };
							}
							if (filter.title === 'dealer') {
								return { ...filter, options: dealerList };
							}
							return filter;
						})
					}));
				}).catch(err => console.error("Error fetching dealers and areas:", err));
				promises.push(p7);
			}

			try {
				await Promise.allSettled(promises);
			} catch (e) {
				console.error("Error waiting for dynamic dropdown options:", e);
			} finally {
				setIsDropdownLoading(false);
			}
		}
		fetchData();
	}, [leadType, availableFilterValues]);


	// Handle Upload leads/File
	const handleUploadFile = () => {
		setIsUploadModalOpen(true);
	};

	// Handle Upload leads Data
	const handleUpload = async (formData, leadType) => {
		return await uploadleads(formData, leadType);
	};

	const handleRetailUpload = async (formData) => {
		return await uploadRetailLeads(formData);
	};

	// Handle Date Range Filter
	const toggleDateRange = (key) => {
		setIsDateRangeOpen(true);
		setOpenDateRangeKey(prev => (prev === key ? null : key));
	};

	const convertISTDateRangeToUTC = (startDate, endDate, lable) => {
		let istStart, istEnd;
		switch (lable) {
			case 'Today':
			case 'Yesterday':
				istStart = new Date(startDate);
				istStart.setDate(istStart.getDate() - 1); // Move the end date to the next day
				istStart.setUTCHours(18, 30, 0, 0); // IST 00:00 AM => UTC 18:30 (previous day)

				istEnd = new Date(endDate);
				istEnd.setUTCHours(18, 29, 59, 999); // Set time to 11:59 PM IST (converted to UTC)

				return { startUTC: istStart, endUTC: istEnd };

			case 'Last Week':
			case 'This Week':
			case 'This Month':
				istStart = new Date(startDate);
				istStart.setUTCHours(18, 30, 0, 0); // IST 00:00 AM => UTC 18:30 (previous day)

				istEnd = new Date(endDate);
				istEnd.setUTCHours(18, 29, 59, 999); // Set time to 11:59 PM IST (converted to UTC)

				return { startUTC: istStart, endUTC: istEnd };

			case 'Last 7 Days':
				istStart = new Date(startDate);
				istStart.setUTCHours(18, 30, 0, 0); // IST 00:00 AM => UTC 18:30 (previous day)

				istEnd = new Date(endDate);
				istEnd.setUTCHours(18, 29, 59, 999); // Set time to 11:59 PM IST (converted to UTC)

				return { startUTC: istStart, endUTC: istEnd };

			case 'Last Month':
				istStart = new Date(startDate);
				istStart.setUTCHours(18, 30, 0, 0); // IST 00:00 AM => UTC 18:30 (previous day)

				istEnd = new Date(endDate);
				istEnd.setUTCHours(18, 29, 59, 999); // Set time to 11:59 PM IST (converted to UTC)

				return { startUTC: istStart, endUTC: istEnd };

			default:
				istStart = new Date(startDate);
				istStart.setUTCHours(18, 30, 0, 0); // IST 00:00 AM => UTC 18:30

				istEnd = new Date(endDate);
				istEnd.setDate(istEnd.getDate() + 1);
				istEnd.setUTCHours(18, 29, 59, 999); // IST 11:59:59 PM => UTC 18:29:59.999

				return { startUTC: istStart, endUTC: istEnd };
		}
	};

	const handleDateRangeChange = (field, value) => {
		if (!field) return;

		const { startUTC, endUTC } = convertISTDateRangeToUTC(value.startDate, value.endDate, value?.label);

		const updatedValue = {
			startDate: startUTC,
			endDate: endUTC,
		};

		setFilter(prev => ({ ...prev, [field]: updatedValue }));
		setDateRange((prev) => ({ ...prev, [field]: updatedValue }));
		setIsDateRangeOpen(false);
	};

	const isAppliedSearchUnchanged = searchApplied && searchInput.trim() === filterValues.search;

	return (
		<div className={`${isSidebarOpen ? 'flex gap-5' : 'inline-flex overflow-hidden'} max-w-full w-full h-full overflow-hidden rounded-global shadow-global`}>
			<div className={`lead-view-wrapper bg-white rounded-global shadow-global transition-width duration-300 h-full ${isSidebarOpen ? '2xl:w-[calc(80%-10px)] w-[calc(75%-10px)]' : 'flex-[100] max-w-full w-full'}`}>
				<div className="grid-layout h-full">
					<div className="w-full gap-4 lead-view-header flex flex-wrap items-center justify-between border-b border-default-200 py-4 px-6">
						{/* Search Input */}

						{isLoading || !matchedPermission ? (
							<div className="w-full flex items-center justify-center gap-2">
								{/* <Spinner color="success" className="!text-sm" /> */}
								<p className="!text-success text-medium">Loading...</p>
							</div>
						) : (
							<>
								<div className="flex items-center 2xl:gap-5 gap-3 flex-row-reverse">
									<div className="flex flex-row items-center gap-2">
										{allLeadsData?.ordered &&
											<div className="flex justify-between gap-5 border border-default-200 h-10 px-6 rounded-[13px] bg-default-50">
												<div className="flex items-center justify-center whitespace-nowrap">
													<span>Ordered : </span>
													<span className="ml-1"><b>{allLeadsData?.ordered}</b></span>
												</div>
												<div className="flex items-center text-gray-300">|</div>
												<div className="flex items-center justify-center whitespace-nowrap">
													<span>Ordered After 3 Months : </span>
													<span className="ml-1"><b>{allLeadsData?.orderedAfterTwoMonths}</b></span>
												</div>
												<div className="flex items-center text-gray-300">|</div>
												<div className="flex items-center justify-center whitespace-nowrap">
													<span>Cancelled : </span>
													<span className="ml-1"><b>{allLeadsData?.orderedCancelled}</b></span>
												</div>
												<div className="flex items-center text-gray-300">|</div>
												<div className="flex items-center justify-center whitespace-nowrap">
													<span>Total : </span>
													<span className="ml-1"><b>{(allLeadsData?.ordered || 0) - (allLeadsData?.orderedAfterTwoMonths || 0) - (allLeadsData?.orderedCancelled || 0)}</b></span>
												</div>
											</div>
										}
										{allLeadsData?.olaAddonDocs &&
											<>
												<Button
													size="md"
													className="btn-outline ml-2"
												>
													<span>{filterValues?.ola_addon_status} : </span>
													<span className="ml-1">{allLeadsData?.olaAddonDocs}</span>
												</Button>
											</>
										}
									</div>
									{(allLeadsData?.ordered || allLeadsData?.olaAddonDocs) && (
										<div className="flex items-center text-gray-300">|</div>
									)}
									<div className="flex items-center gap-2 border border-default-200 rounded-[13px] hover:bg-gray-100">
										<Input
											classNames={{
												base: "max-w-full sm:max-w-[350px] h-10",
												inputWrapper: "h-full font-normal text-default-500 bg-transparent  rounded-[13px]",
											}}
											onChange={handleSearchInputChange}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													searchFunctions();
												}
											}}
											value={searchInput}
											placeholder="Type to search..."
											size="sm"
											startContent={<SearchIcon size={18} />}
											type="text"
										/>
										<Button
											onPress={isAppliedSearchUnchanged ? clearSearch : searchFunctions}
											size="sm"
											className="h-6 min-w-10 p-0  mr-2 bg-success text-white rounded-[13px]"
										>
											{isAppliedSearchUnchanged ? <IoClose /> : <FaArrowRight />}
										</Button>
									</div>

									<div className="flex items-center text-gray-300">|</div>
									<div className="total-leads-documents flex items-center whitespace-nowrap gap-1">
										<span className="text-medium text-success">Total {leadType} Leads :</span>
										<span className="text-large font-bold">{formatNumberValue(allLeadsData.totalDocs) || 'N/A'}</span>
									</div>
								</div>

								{/* Filter & Column Selector */}
								<div className="leads-data-filter flex items-center 2xl:gap-5 gap-3">
									<Button
										onPress={toggleFilterSidebar}
										className={` hover:bg-button font-mediem text-medium hover:border-secondary border-1 border-gray-200 text-gray-500 hover:text-white transition-colors duration-500 ${isSidebarOpen ? "bg-button text-white border-secondary" : "hover:bg-button hover:border-secondary hover:text-white"
											}`}
										variant="bordered"
										startContent={<FilterIcon width="30px" height="30px" />}
									>
										<p className="hidden 2xl:block">Filter</p>
									</Button>

									{/* Column Selector Popover */}
									<DynamicPopover
										leadType={leadType}
										isLoading={columnLoading}
										buttonText="Columns"
										items={columnsData}
										selectedColumns={selectedColumns}
										setSelectedColumns={setSelectedColumns}
										toggleItem={toggleItem}
										placeholder="Search columns..."
										popoverTitle="Select Columns"
										savePreference={savePreference} fetchPreferences={fetchPreferences} deletePreference={deletePreference}
									/>

									{(matchedPermission.adminType === "SUPER") || (matchedPermission && (matchedPermission?.permission?.importFlag === 1 || matchedPermission?.permission?.downloadFlag === 1)) ? (
										<div className="flex items-center text-gray-300">|</div>
									) : null}

									{(matchedPermission?.adminType === "SUPER" && leadType !== "All" && leadType !== "Dialshreeinbound") || (matchedPermission && matchedPermission?.permission?.importFlag === 1) ? (
										<>
											<Button
												className={`hover:bg-button font-mediem text-medium hover:border-secondary border-1 border-gray-200 text-gray-500 hover:text-white transition-colors duration-500 ${isUploadModalOpen ? "bg-button text-white border-secondary" : "hover:bg-button hover:border-secondary hover:text-white"}`}
												variant="bordered"
												startContent={<ImportIcon width="26px" height="26px" />}
												onPress={handleUploadFile}
											>
												<p className="hidden 2xl:block">Import</p>
											</Button>
											<UploadFile
												leadType={leadType}
												getAllLeads={getAllLeads}
												isOpen={isUploadModalOpen}
												setIsUploadModalOpen={setIsUploadModalOpen}
												onOpen={() => setIsUploadModalOpen(true)}
												onClose={() => setIsUploadModalOpen(false)}
												onUpload={handleUpload}
											/>
										</>
									) : null}

									{leadType === 'Revolt' && ((matchedPermission?.adminType === "SUPER") || (matchedPermission && matchedPermission?.permission?.importFlag === 1)) ? (
										<>
											<Button
												className={`hover:bg-button font-mediem text-medium hover:border-secondary border-1 border-gray-200 text-gray-500 hover:text-white transition-colors duration-500 ${isRetailModalOpen ? "bg-button text-white border-secondary" : "hover:bg-button hover:border-secondary hover:text-white"}`}
												variant="bordered"
												startContent={<ImportIcon width="26px" height="26px" />}
												onPress={() => setIsRetailModalOpen(true)}
											>
												<p className="hidden 2xl:block">Retail import</p>
											</Button>
											<UploadRetailFile
												leadType={leadType}
												getAllLeads={getAllLeads}
												isOpen={isRetailModalOpen}
												setIsUploadModalOpen={setIsRetailModalOpen}
												onOpen={() => setIsRetailModalOpen(true)}
												onClose={() => setIsRetailModalOpen(false)}
												onUpload={handleRetailUpload}
											/>
										</>
									) : null}

									{(matchedPermission.adminType === "SUPER") || (matchedPermission && matchedPermission?.permission?.downloadFlag === 1) ? (
										<>
											<Button
												className="hover:bg-button font-mediem text-medium hover:border-secondary border-1 border-gray-200 text-gray-500 hover:text-white transition-colors duration-500"
												variant="bordered"
												startContent={downloading ? <Spinner size="sm" color="success" variant="spinner" /> : <DownloadIcon size={33} />}
												// onPress={(Array.isArray(selectedFilters) && selectedFilters.length > 0) ? toggleDownloadLeadsModal : handleConfirmDownloadLeads}
												onPress={toggleDownloadLeadsModal}
											>
												<p className="hidden 2xl:block"></p>
											</Button>
											{isDownloadLeadsModal && (
												<ModalBox
													title={'Confirm Download Leads'}
													isOpen={isDownloadLeadsModal}
													onOpen={() => setIsDownloadLeadsModal(true)}
													onClose={() => setIsDownloadLeadsModal(false)}
													handleConfirmUpdate={handleDownloadLeads}
												>
													<div className="flex flex-col gap-[10px]">
														<p>Are you sure! You want to <span className="text-amber-600 font-semibold"> download the {(Array.isArray(selectedFilters) && selectedFilters.length > 0) ? 'applied filter' : ''} leads?</span></p>
														{(Array.isArray(selectedFilters) && selectedFilters.length > 0) && (
															<p><span className='font-bold'>Filters</span> : <span className='text-success'>{selectedFilters.join(", ")}</span></p>
														)}
														<div className="flex items-center gap-2 mt-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
															<input
																type="checkbox"
																id="dynamicColumnsCheckbox"
																checked={useDynamicColumns}
																onChange={(e) => setUseDynamicColumns(e.target.checked)}
																className="w-4 h-4 text-amber-600 bg-gray-100 border-gray-300 rounded focus:ring-amber-500 cursor-pointer"
															/>
															<label htmlFor="dynamicColumnsCheckbox" className="text-sm font-medium text-gray-700 cursor-pointer select-none">
																Export selected columns only
															</label>
														</div>
														{useDynamicColumns && (
															<p className="text-xs text-gray-500">
																<span className="font-semibold">{selectedColumns.length}</span> columns selected from table view
															</p>
														)}
													</div>
												</ModalBox>
											)}
										</>
									) : null}
								</div>
							</>
						)}
					</div>

					<div className="leadsData overflow-x-auto h-[calc(100%-72px)] flex items-center justify-center">
						{(loading || isLoading) ? (
							<div className="w-full flex items-center justify-center gap-2">
								<Spinner color="success" />
								<p className="!text-success text-3xl">Loading...</p>
							</div>
						) : <LeadsData getGoogleSignedRecordingUrl={getGoogleSignedRecordingUrl} apiType={apiType} allLeadsData={allLeadsData} columns={columnsData} selectedColumns={selectedColumns} setPageLimit={setPageLimit} pageLimit={pageLimit} getAllLeads={getAllLeads} getleadViewDetails={getleadViewDetails} getleadDetails={getleadDetails} leadType={leadType} fetchOEMHistory={fetchOEMHistory} debouncedSearch={debouncedSearch} filter={filter} />}
					</div>
				</div>
			</div>
			<div className={`lead-view-wrapper  bg-white rounded-global shadow-global transition-width duration-300 overflow-y-auto min-h-full ${isSidebarOpen ? '2xl:w-[calc(20%-10px)] w-[calc(25%-10px)]' : 'w-0 opacity-0 pointer-events-none '}`}>
				<FilterData leadType={leadType} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} filterData={filterData} setFilter={setFilter} filter={filter} handleConfirmFilter={handleConfirmFilter} isOpen={isOpen} onOpen={onOpen} onClose={onClose} applyFilter={applyFilter} addFilter={addFilter} setAddFilter={setAddFilter} search={search} setSearch={setSearch} searchTerm={searchTerm} setSearchTerm={setSearchTerm} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} toggleResetFilter={toggleResetFilter} handleDateRangeChange={handleDateRangeChange} toggleDateRange={toggleDateRange} isDateRangeOpen={isDateRangeOpen} dateRange={dateRange} setDateRange={setDateRange} setIsDateRangeOpen={setIsDateRangeOpen} savePreference={savePreference} fetchPreferences={fetchPreferences} deletePreference={deletePreference} openDateRangeKey={openDateRangeKey}
					checkedFilters={checkedFilters}
					setCheckedFilters={setCheckedFilters}
					dateRangeFilters={dateRangeFilters}
					setDateRangeFilters={setDateRangeFilters}
					isDropdownLoading={isDropdownLoading}
				/>
			</div>
			<Toaster
				position="top-right"
				reverseOrder={false}
			/>
		</div>
	);
}

export default LeadsDataWithFilter;


